export const formatTableOrderValuesToPickUpInfo = (
    table: string,
    terrace: boolean,
    token: string
) => {
    return `tableNumber=${table}&terrace=${
        terrace ? 'true' : 'false'
    }&token=${token}`
}

export const getTableOrderValuesFromPickUpInfo = (
    pickUpInfo: string
): {
    table: string,
    terrace: boolean,
    token: string
} => {
    const tableNumberRegex = /tableNumber=([^&]+)/
    const terraceRegex = /terrace=([^&]+)/
    const tokenRegex = /token=([^&]+)/

    const tableNumberMatch = pickUpInfo.match(tableNumberRegex)
    const terraceMatch = pickUpInfo.match(terraceRegex)
    const tokenMatch = pickUpInfo.match(tokenRegex)

    const tableNumber = tableNumberMatch ? tableNumberMatch[1] : ''
    const terraceString = terraceMatch ? terraceMatch[1] : 'false'
    const token = tokenMatch ? tokenMatch[1] : ''

    return { table: tableNumber, terrace: terraceString === 'true', token }
}

export const formatTableToDisplay = (table: string) => {
    return table.replace(/^T0*/, '')
}
